import React from 'react';
import './EmpowerHuntingResources.css';

const LinkedinIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="#0A66C2" style={{ marginRight: '10px', verticalAlign: 'middle', marginTop: '2px' }}>
      <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>
    </svg>
);

const NaukriIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="#0072C6" style={{ marginRight: '10px', verticalAlign: 'middle', marginTop: '2px' }}>
        <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm5.187 16.486L14.7 13.59c-.279-.327-.584-.572-.942-.716.294.275.467.666.467 1.092v2.52h-2.181v-8.972h2.181v4.321c0 .438.225.845.596 1.066l2.366 3.585h0zm-6.233-1.09v-7.882H8.77l-1.921 5.485V7.514H4.668v8.972h2.182l1.923-5.595v5.595h2.181z"/>
    </svg>
);

const IndeedIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="#2164F4" style={{ marginRight: '10px', verticalAlign: 'middle', marginTop: '2px' }}>
        <path d="M6.353 19.34L3.25 15.118v-3.792c0-1.892 1.536-3.428 3.428-3.428h2.09c.408 0 .74-.33.74-.74v-1.63c0-2.31-1.87-4.183-4.18-4.183H3.25V-.005h1.792c3.425 0 6.205 2.78 6.205 6.205v9.117c0 1.25-.497 2.45-1.382 3.334l-3.51 3.688zM19.167 4.184h-4.383v15.228a6.388 6.388 0 0 1-5.7-6.347V3.88h-2.91v9.186c0 5.163 4.186 9.35 9.35 9.35h3.642V4.184z"/>
    </svg>
);

const GlassdoorIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="#0CAA41" style={{ marginRight: '10px', verticalAlign: 'middle', marginTop: '2px' }}>
        <path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm3.324 16.59h-6.65v-2.18h6.65v2.18zm1.09-3.796h-8.831v-2.18h8.83v2.18zm-.914-3.795H8.5V6.82h7v2.18z"/>
    </svg>
);

const CompanyIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="#4B5563" style={{ marginRight: '10px', verticalAlign: 'middle', marginTop: '2px' }}>
        <path d="M19 4h-3V2c0-1.103-.897-2-2-2H10c-1.103 0-2 .897-2 2v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm-9-2h4v2h-4V2zm9 18H5V6h14v14z"/>
        <path d="M7 8h2v2H7zm4 0h2v2h-2zm4 0h2v2h-2zm-8 4h2v2H7zm4 0h2v2h-2zm4 0h2v2h-2zm-8 4h2v2H7zm4 0h2v2h-2zm4 0h2v2h-2z"/>
    </svg>
);

const EmpowerHuntingResources = () => {
    return (
        <section className="hunting-section">
            <div className="hunting-container">
                <h2 className="hunting-title">Empower Hunting Resources</h2>
                <h3 className="hunting-tagline">Find Your Next Opportunity</h3>

                <p className="hunting-description">
                    A dedicated space to help learners and professionals find the right job opportunities in the pharmaceutical sector. We have curated a list of reliable job portals and networking platforms tailored for pharma and healthcare roles.
                </p>

                <div className="hunting-content-block">
                    <p className="hunting-description">
                        <strong>Recommended Job Platforms:</strong>
                    </p>
                    <ul className="hunting-list">
                        <li style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '15px' }}>
                            <div style={{ flexShrink: 0 }}><LinkedinIcon /></div>
                            <div>
                                <a href="https://www.linkedin.com" target="_blank" rel="noopener noreferrer" className="platform-link" style={{ color: '#0A66C2', textDecoration: 'none', fontWeight: 'bold' }}>
                                    LinkedIn
                                </a>: The premier professional networking site. Essential for connecting with recruiters and industry leaders.
                            </div>
                        </li>
                        <li style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '15px' }}>
                            <div style={{ flexShrink: 0 }}><NaukriIcon /></div>
                            <div>
                                <a href="https://www.naukri.com" target="_blank" rel="noopener noreferrer" className="platform-link" style={{ color: '#0072C6', textDecoration: 'none', fontWeight: 'bold' }}>
                                    Naukri
                                </a>: A leading job portal heavily used by Indian pharma companies for all levels.
                            </div>
                        </li>
                        <li style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '15px' }}>
                            <div style={{ flexShrink: 0 }}><IndeedIcon /></div>
                            <div>
                                <a href="https://www.indeed.com" target="_blank" rel="noopener noreferrer" className="platform-link" style={{ color: '#2164F4', textDecoration: 'none', fontWeight: 'bold' }}>
                                    Indeed
                                </a>: A global job search engine that aggregates listings from thousands of websites.
                            </div>
                        </li>
                        <li style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '15px' }}>
                            <div style={{ flexShrink: 0 }}><GlassdoorIcon /></div>
                            <div>
                                <a href="https://www.glassdoor.com" target="_blank" rel="noopener noreferrer" className="platform-link" style={{ color: '#0CAA41', textDecoration: 'none', fontWeight: 'bold' }}>
                                    Glassdoor
                                </a>: Excellent for company reviews, salary insights, and job listings.
                            </div>
                        </li>
                        <li style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '15px' }}>
                            <div style={{ flexShrink: 0 }}><CompanyIcon /></div>
                            <div>
                                <a href="https://www.google.com/search?q=pharma+companies+careers" target="_blank" rel="noopener noreferrer" className="platform-link" style={{ color: '#4B5563', textDecoration: 'none', fontWeight: 'bold' }}>
                                    Company Career Pages
                                </a>: Always check the official career pages of major pharma companies (e.g., Sun Pharma, Cipla, Dr. Reddy's) for direct openings.
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </section>
    );
};

export default EmpowerHuntingResources;
